{
  "home": {
    "menu": {
      "title": "Главная"
    },
    "page": {
      "title": "Главная"
    },
    "search": {
      "placeholder": "Поиск"
    },
    "map": {
      "label": "Карта активности",
      "loading": "Загрузка карты…",
      "error": "Не удалось загрузить данные карты.",
      "empty": "Нет данных за этот период.",
      "emptyAssets": "Нет активов за этот период.",
      "emptyActivity": "Нет активности за этот период.",
      "emptyRoutines": "Нет активности по рутинам за этот период.",
      "emptyProducts": "Нет продуктов за этот период.",
      "noResults": "Нет результатов по этому запросу."
    },
    "activity": {
      "title": "Активность",
      "total": "Всего {{count}}",
      "viewAll": "Показать все",
      "solved": "Решено",
      "pending": "В ожидании",
      "urgent": "Срочно",
      "error": "Не удалось загрузить данные активности",
      "empty": "Нет активности за этот период",
      "plot": "Показать активность на карте"
    },
    "cards": {
      "viewAll": "Показать все",
      "error": "Не удалось загрузить данные"
    },
    "assets": {
      "title": "Активы",
      "empty": "Нет активов за этот период",
      "plot": "Показать активы на карте",
      "filterBy": "Фильтровать карту по {{status}}"
    },
    "routines": {
      "title": "Рутины",
      "empty": "Нет рутин",
      "plot": "Показать места рутин на карте",
      "filterBy": "Показать {{name}} на карте"
    },
    "products": {
      "title": "Продукты",
      "empty": "Нет продуктов",
      "plot": "Показать продукты на карте",
      "filterBy": "Показать {{name}} на карте"
    },
    "campaigns": {
      "title": "Кампании",
      "empty": "Нет кампаний"
    },
    "customers": {
      "title": "Клиенты",
      "empty": "Нет клиентов",
      "sample": "Образцы данных",
      "active": "Активные",
      "pending": "В ожидании",
      "new": "Новые"
    },
    "plot": {
      "activity": "Показ активности",
      "asset": "Показ активов",
      "routine": "Показ мест рутин",
      "product": "Показ продуктов"
    },
    "timeRange": {
      "label": "Период времени",
      "today": {
        "label": "Сегодня",
        "a11y": "Сегодня"
      },
      "7d": {
        "label": "7D",
        "a11y": "Последние 7 дней"
      },
      "30d": {
        "label": "30D",
        "a11y": "Последние 30 дней"
      },
      "90d": {
        "label": "90D",
        "a11y": "Последние 90 дней"
      },
      "1y": {
        "label": "1Y",
        "a11y": "Последний год"
      },
      "all": {
        "label": "Все",
        "a11y": "За все время"
      }
    }
  },
  "accountPage": {
    "header": {
      "accountTypes": "Типы аккаунтов",
      "newUsersSetup": "Новые пользователи будут добавлены как"
    },
    "types": {
      "general": "Общий",
      "admin": "Администратор",
      "restricted": "Ограниченный",
      "anonymous": "Анонимный"
    },
    "table": {
      "headers": {
        "accountType": "Тип аккаунта",
        "accessActivity": "Доступ к активности?",
        "accessSettings": "Доступ к настройкам?"
      },
      "columns": {
        "restrictedToActivitiesNote": "Ограничено общими активами и группами",
        "generalToSettingsNote": "Ограничено активами и людьми"
      }
    },
    "info": {
      "header": "Объяснение типов аккаунтов",
      "admin": "Идеально для владельцев рабочих мест, старших менеджеров и офисных администраторов.",
      "general": "Идеально для штатных сотрудников и работников. (Наша рекомендуемая настройка по умолчанию.)",
      "restricted": "Идеально для известных посетителей, поставщиков, работников с частичной занятостью и подрядчиков, которым требуется частичный или ограниченный доступ.",
      "anonymous": "Для лиц, которые не зарегистрировались в Gripp. Они могут отправлять только отчеты, заметки или рутины на основе того, что они сканируют."
    },
    "menu": {
      "accountPage": "Аккаунт",
      "settingsPage": "Настройки",
      "workspaceSettingsPage": "Настройки рабочего пространства"
    },
    "workplaceTitle": "Управление рабочим местом и данными",
    "downloadData": "Загрузить данные",
    "dataExport": {
      "splitToRows": "Разделить на строки",
      "addAllAssetInfo": "Добавить всю информацию об активе",
      "cancel": "Отмена",
      "title": "Экспорт данных",
      "download": "Загрузить"
    }
  },
  "account": {
    "allWorkspaces": "Все рабочие пространства",
    "create": {
      "button": "Добавить пользователя",
      "form": {
        "email": "Электронная почта",
        "firstName": "Имя",
        "lastName": "Фамилия",
        "role": "Роль"
      },
      "validation": {
        "emailRequired": "Электронная почта обязательна",
        "role": "Роль обязательна",
        "validEmail": "Пожалуйста, введите действительный адрес электронной почты"
      }
    },
    "filter": {
      "apply": "Применить",
      "columnSelection": "Столбцы",
      "columns": {
        "createdAt": "Дата присоединения",
        "createdDate": "Дата присоединения",
        "createdTime": "Время присоединения",
        "email": "Электронная почта",
        "groups": "Группы",
        "groupNames": "Названия групп",
        "assets": "Активы",
        "jobTitle": "Должность",
        "location": "Местоположение",
        "name": "Имя (обязательно)",
        "phone": "Номер телефона",
        "roles": "Роль",
        "workspace": "Рабочее пространство"
      },
      "searchPlaceholder": "Поиск по имени, номеру или email",
      "columnButton": "Столбцы",
      "groupsButton": "Группы",
      "accountTypesButton": "Роли",
      "noAccountTypes": "Нет ролей",
      "groups": "Группы",
      "accountTypes": "Роли",
      "default": "По умолчанию",
      "viewResults": "Показать {{count}} результатов"
    },
    "groups": {
      "addPeopleTo": "Добавить {{count}} человек в:",
      "addPersonTo": "Добавить 1 человек в:"
    },
    "list": {
      "accountType": "Роль",
      "role": "Роль",
      "added": "Дата присоединения",
      "createdDate": "Дата присоединения",
      "createdTime": "Время присоединения",
      "email": "Электронная почта",
      "groups": "Группы",
      "assets": "Активы",
      "activity": "Активность",
      "jobTitle": "Должность",
      "location": "Местоположение",
      "name": "Имя",
      "phone": "Номер телефона",
      "workspace": "Рабочее пространство"
    },
    "topBar": {
      "peopleSelected": "Выбрано {{count}} человек",
      "personSelected": "Выбран 1 человек"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Да",
        "secondaryButton": "Отмена",
        "title": "Вы уверены, что хотите удалить {{accountName}}?"
      }
    },
    "detail": {
      "removeAccount": "Удалить аккаунт",
      "viewActivity": "Показать активность",
      "activityPanel": {
        "description": "Включает активность, которую этот человек создал, на которую ответил, или к которой ему был предоставлен доступ."
      }
    }
  },
  "activity": {
    "filter": {
      "cancel": "Отмена",
      "groups": "Группы",
      "activityOptions": "Параметры активности",
      "activityTypes": "Типы активности",
      "options": "Опции",
      "types": "Типы",
      "notes": "Заметки",
      "note": "Заметка",
      "pending": "В ожидании",
      "reset": "Сбросить",
      "routines": "Рутины",
      "searchPlaceholder": "Поиск заголовков активности или названия актива",
      "searchLabels": "Поиск меток",
      "solved": "Решено",
      "title": "Фильтры",
      "labels": "Метки",
      "urgent": "Срочно",
      "date": "Дата",
      "all": "Все",
      "day": "день",
      "week": "неделя",
      "month": "месяц",
      "today": "Сегодня",
      "thisWeek": "Последние 7 дней",
      "thisMonth": "Последние 30 дней",
      "custom": "Произвольный",
      "customDate": "Произвольная дата",
      "from": "С",
      "to": "До",
      "mentions": "Упоминания",
      "scheduled": "Запланировано",
      "default": "По умолчанию",
      "notScheduled": "Не запланировано",
      "pinned": "Закреплено",
      "everything": "Все",
      "onlyMentions": "Только упоминания",
      "onlyPinned": "Только закрепленные",
      "onlyScheduled": "Только запланированные",
      "sort": "Сортировка",
      "viewResults": "Показать {{count}} результатов",
      "combinedGroups": "Комбинированная фильтрация",
      "notGrouped": "(без группы)",
      "notLabeled": "(без метки)"
    },
    "search": {
      "title": "Поиск",
      "search": "Поиск",
      "recentSearches": "Недавние поиски"
    },
    "header": {
      "title": "Активность",
      "view": "Просмотр",
      "viewAll": "Просмотреть все"
    },
    "list": {
      "youAreMentioned": "Вас упомянули."
    },
    "menu": {
      "title": "Активность",
      "titlePlural": "Активности"
    },
    "calendar": {
      "truncated": "Показано {{shown}} из {{total}} активностей. Добавьте фильтр, чтобы увидеть все."
    },
    "textEmpty": "Нет активности",
    "topBar": {
      "results": "результатов"
    },
    "sort": {
      "mostRecent": "Последнее обновление",
      "reminderDate": "Дата напоминания",
      "oldest": "Дата создания"
    },
    "edit": {
      "tab": {
        "activity": "Активность",
        "routine": "Процедура"
      }
    },
    "tapScan": "Нажмите \"+\" для сканирования активов или кодов приглашения.",
    "messageBubble": {
      "joinWorkspace": {
        "title": "Присоединяйтесь к рабочему пространству!",
        "description": "Вы еще не в рабочем пространстве.\nОтсканируйте код приглашения, чтобы присоединиться к\nрабочему пространству!"
      },
      "addActivity": {
        "title": "Добавить активность",
        "description": "У вас еще нет активности.\nНажмите '+' чтобы добавить отчет или заметку об активе и держать команду в курсе."
      },
      "addAsset": {
        "title": "Добавить активы",
        "description": "У вас еще нет активов.\nНажмите '+' чтобы отсканировать и добавить ваш первый актив для начала."
      },
      "or": "или",
      "newSub": "начать новую подписку",
      "here": "здесь"
    }
  },
  "admin": {
    "menu": {
      "admin": "Люди",
      "workspaces": "Рабочие пространства"
    }
  },
  "alerts": {
    "addAnother": "Добавить еще",
    "create": {
      "alertName": "Название оповещения",
      "asset(s)": "Актив(ы)",
      "assetSearchPlaceholder": "Поиск названия актива",
      "assets": "Активы",
      "doNotAlert": "<0>(Необязательно)</0><1>Не оповещать между:</1>",
      "groupSearchPlaceholder": "Поиск названия группы",
      "groups": "Группы",
      "promptRoutine": "<0>(Необязательно)</0><1>Выберите рутину</1><0>для запроса с этим оповещением:</0>",
      "promptRoutinePlaceholder": "рутина не выбрана",
      "title": "Создать оповещение",
      "what": "1. Выберите что:",
      "when": "3. Выберите когда:",
      "why": "2. Выберите почему:"
    },
    "setAlert": "Добавить оповещение",
    "setANewAlert": "Установить новое оповещение",
    "createButton": "Создать новое",
    "createNewAlert": "Создать новое оповещение",
    "createAlert": "Создать оповещение",
    "alert": "Оповещение",
    "alerts": "Оповещения",
    "deleteAlert": "Удалить оповещение",
    "nextAlert": "Следующее оповещение: ",
    "lastAlert": "Последнее оповещение: ",
    "lastAlertNA": "Н/Д",
    "confirm": "Подтвердить",
    "currently": "В настоящее время: ",
    "abovePlaceholder": "выше",
    "belowPlaceholder": "ниже",
    "editAlert": "Редактировать оповещение",
    "intervalValue": "Значение интервала",
    "newAlert": "Новое оповещение",
    "number": "Число",
    "minDropdownPlaceholder": "Когда оно выше  _____ ",
    "maxDropdownPlaceholder": "Когда оно ниже  _____ ",
    "setAlertLogic": "Установить логику оповещения",
    "setAlertLogicPlaceholder": "Выберите логику оповещения",
    "optionalSettings": "Необязательные настройки",
    "customLabelTitle": "Настроить заголовок оповещения",
    "blackoutDates": "Даты блокировки?",
    "alertDate": "Дата оповещения",
    "alertTime": "Время оповещения",
    "startDate": "Дата начала",
    "starting": "Начиная",
    "day": "день",
    "days": "дней",
    "togo": "осталось",
    "completions": "завершений",
    "recorded": "записано",
    "elapsed": "прошло",
    "OR": "ИЛИ",
    "or": "или",
    "on": "на",
    "at": "в",
    "skipped": "пропущено",
    "every": "каждый",
    "Every": "Каждый",
    "startingValue": "Начальное значение",
    "intervalWindowPerAsset": "Интервал по активу",
    "managedOnGroup": "Управляется на уровне группы: {{group}}",
    "noRoutinesOnGroup": "В этой группе нет назначенных рутин. Сначала назначьте рутину, чтобы задать оповещение для группы.",
    "managedOnGroupNote": "Это оповещение задано для группы {{group}}. Здесь можно изменить только начальную точку этого актива.",
    "onDate": "В определенную дату",
    "onDays": "Каждые ___ дней",
    "onDayInterval": "Напомнить мне через ___",
    "onDayIntervalUnit": "Интервал",
    "dateInterval": {
      "minutes": "Минуты",
      "hours": "Часы",
      "days": "Дни",
      "weeks": "Недели",
      "months": "Месяцы"
    },
    "onDaysSkipped": "Каждые ___ дней рутина не завершена",
    "onRoutineCompletions": "Каждые ___ раз рутина завершена",
    "onInterval": "На основе интервала",
    "selectRoutineToPrompt": "Выберите рутину для запроса",
    "selectAlertingLogic": "Выберите логику оповещения",
    "customLabelWhenAlertOccurs": "Пользовательская метка при возникновении оповещения",
    "selectRoutine": "Выберите рутину",
    "reset": "Сбросить",
    "edit": {
      "alertName": "Название оповещения",
      "asset(s)": "Актив(ы)",
      "assets": "Активы",
      "doNotAlert": "Не оповещать между",
      "groups": "Группы",
      "none": "Нет",
      "promptRoutine": "<0>Выберите рутину</0><1>для запроса с этим оповещением</1>",
      "promptRoutinePlaceholder": "рутина не выбрана",
      "setFor": "Это оповещение установлено для",
      "setOn": "Настроить оповещение на",
      "title": "Редактировать оповещение",
      "when": "Когда"
    },
    "menu": {
      "confirmDelete": {
        "primaryButton": "Да",
        "secondaryButton": "Отмена",
        "title": "Вы уверены, что хотите удалить {{alertName}}?"
      },
      "delete": "Удалить",
      "disableAlert": "Отключить оповещение",
      "enableAlert": "Включить оповещение",
      "viewAlertActivities": "Просмотр активности оповещений"
    },
    "new": {
      "header": "Оповещения > Создать оповещение"
    },
    "title": "Автоматизация",
    "trigger": {
      "counter": {
        "ceiling": "Счетчик превышает",
        "daysSinceCompleted": "Рутина не была завершена в течение",
        "daysSinceCompleted-end": "Дней",
        "every": "Каждые",
        "every-end": "Дней",
        "floor": "Счетчик опускается ниже",
        "onCompletionCount": "Рутина была завершена каждые",
        "onCompletionCount-end": "Раз",
        "onInterval": "Счетчик достигает интервала"
      },
      "default": {
        "daysSinceCompleted": "Рутина не была завершена в течение",
        "daysSinceCompleted-end": "Дней",
        "every": "Каждые",
        "every-end": "Дней",
        "onCompletionCount": "Рутина была завершена каждые",
        "onCompletionCount-end": "Раз"
      }
    },
    "validation": {
      "alertTypeRequired": "Требуется тип оповещения",
      "inputRequired": "Требуется ввод",
      "invalidDate": "Неверная дата",
      "startDateRequiredForDays": "Требуется дата начала для типа оповещения Дни",
      "routineIdRequiredForInterval": "Требуется id рутины для интервала",
      "routineRequired": "Выберите рутину"
    },
    "setInterval": "Установить интервал",
    "numberOfDays": "Количество дней",
    "numberOfTimes": "Количество раз"
  },
  "asset": {
    "activityExport": "Экспорт активности",
    "advancedAssetInformation": "Расширенная информация об активе",
    "customAlert": {
      "tagAlreadyAdded": "Этот тег уже добавлен к этому активу.",
      "tryAnotherTag": "Этот тег уже используется и не может быть выбран, пожалуйста, попробуйте другой тег."
    },
    "delete": {
      "button": "Удалить актив",
      "cancel": "Отмена",
      "confirm": "Удалить",
      "title": "Вы уверены, что хотите удалить этот актив?"
    },
    "description": "Описание",
    "descriptionPlaceholder": "Необязательно",
    "details": "Детали",
    "detailsPlaceHolder": "Необязательно",
    "editTitle": "Информация об активе",
    "groups": "Группы",
    "groupsPlaceHolder": "(Необязательно) Выберите группу(ы)",
    "groupsSearchPlaceHolder": "Поиск названия группы",
    "header": {
      "buttons": {
        "addNew": "Добавить отчет / заметку",
        "routines": "Рутины",
        "addSomething": "Добавить что-нибудь"
      },
      "recentActivity": "Недавняя активность",
      "activity": "Активность"
    },
    "information": "Информация об активе",
    "mediaLibrary": "Медиатека",
    "name": "Название",
    "namePlaceholder": "Что это?",
    "newIssue": "Что-то новое?",
    "accessRequest": {
      "requestFull": "Запросить полный доступ",
      "requested": "Доступ запрошен",
      "modalTitle": "Запросить полный доступ",
      "modalSubtitle": "Оставьте сообщение, чтобы владелец рабочего пространства знал, зачем вам нужен доступ.",
      "modalPlaceholder": "Необязательное сообщение...",
      "modalSubmit": "Отправить запрос"
    },
    "newTitle": "Настройка актива",
    "tagCode": "Gripp ID",
    "qr": {
      "title": "QR-код Gripp ID",
      "viewQrLabel": "Посмотреть QR-код для {{tagCode}}",
      "tagAlt": "Тег Gripp {{tagCode}}"
    },
    "assetPicture": "Сфотографировать актив",
    "newAsset": "Новый Актив",
    "assetName": "Название",
    "newAdditionalMedia": "Фотографии",
    "secondaryDescription": "Описание",
    "optionalSetting": "Необязательные настройки",
    "hideReportAndNoteOptionsAnonymous": "Скрыть опции отчета и заметки для анонимных посетителей",
    "hideReportAndNote": "Отчет & Заметка",
    "hideForAnonymousVisitors": "Скрыть для анонимных посетителей",
    "files": {
      "title": "Файлы",
      "noFiles": "Файлы не найдены.",
      "addFilesLinks": "Добавить файлы / ссылки",
      "addSheetTitle": "Добавить",
      "addSheetSubtitle": "Файл, медиа или ссылка",
      "uploadFile": "Загрузить файл",
      "addLink": "Добавить ссылку",
      "save": "Сохранить",
      "addFile": "Добавить файл",
      "view": "Показать {{count}} результат",
      "view_plural": "Показать {{count}} результата",
      "camera": "Камера",
      "file": "Файл",
      "unableToPreview": "Предварительный просмотр невозможен",
      "videoLoading": "Загрузка видео…",
      "videoUnavailable": "Видео недоступно"
    },
    "detail": {
      "edit": "Редактировать",
      "delete": "Удалить",
      "delete_asset": "Удалить актив",
      "delete_warning": "Это действие нельзя отменить.",
      "confirmDelete": "Вы уверены, что хотите удалить файл {{fileName}}?"
    },
    "productType": "Тип продукта",
    "serialNumber": "Серийный номер",
    "addons": "Дополнения ({{count}})",
    "addonsNoProduct": "У этого актива нет типа продукта. Назначьте продукт, чтобы выбрать дополнения.",
    "enterTagCode": "Введите код тега",
    "add": "Добавить",
    "cancel": "Отмена",
    "save": "Сохранить",
    "tagCodePlaceholder": "Введите код тега",
    "lookingUpTag": "Поиск тега...",
    "pinnedActivity": "Закрепленная активность",
    "viewAll": "Просмотреть все"
  },
  "assets": {
    "filter": {
      "title": "Фильтры",
      "search": "Поиск",
      "recentSearches": "Недавние поиски",
      "apply": "Применить",
      "reset": "Сбросить",
      "viewResults": "Показать {{count}} результатов",
      "notGrouped": "(без группы)",
      "columnButton": "Столбцы",
      "columnSelection": "Столбцы",
      "columns": {
        "createdAt": "Создано",
        "createdBy": "Создано",
        "description": "Описание",
        "serialNumber": "Серийный номер",
        "productName": "Название продукта",
        "groups": "Группы",
        "groupNames": "Названия групп",
        "lastAddress": "Местоположение",
        "lastScannedAt": "Последнее сканирование",
        "lastUpdated": "Последнее обновление",
        "name": "Название (обязательно)",
        "notes": "# заметок",
        "alerts": "# оповещений",
        "reports": "# активных отчетов",
        "routines": "# рутин",
        "addons": "# дополнений",
        "tagCode": "Gripp ID",
        "workspaces": "Рабочее пространство"
      },
      "groups": "Группы",
      "groupsButton": "Группы",
      "default": "По умолчанию",
      "searchPlaceholder": "Поиск по названию, описанию, продукту, add-ons или Gripp ID",
      "filterToggle": "Комбинированная фильтрация:",
      "combinedGroups": "Комбинированная фильтрация"
    },
    "groups": {
      "addAssetTo": "Добавить 1 актив в:",
      "addAssetsTo": "Добавить {{count}} активов в:"
    },
    "list": {
      "createdAt": "Создано",
      "createdDate": "Дата создания",
      "createdTime": "Время создания",
      "createdBy": "Создано",
      "description": "Описание",
      "serialNumber": "Серийный номер",
      "productName": "Название продукта",
      "groups": "Группы",
      "groupNames": "Названия групп",
      "lastAddress": "Местоположение",
      "lastScannedAt": "Последнее сканирование",
      "lastScannedDate": "Дата последнего сканирования",
      "lastScannedTime": "Время последнего сканирования",
      "lastUpdated": "Последнее обновление",
      "lastUpdatedDate": "Дата последнего обновления",
      "lastUpdatedTime": "Время последнего обновления",
      "name": "Название",
      "notes": "Заметки",
      "alerts": "Оповещения",
      "reports": "Активные отчеты",
      "routines": "Рутины",
      "addons": "Дополнения",
      "tagCode": "Gripp ID",
      "workspaces": "Рабочее пространство"
    },
    "menu": {
      "title": "Активы",
      "titleSingular": "Актив"
    },
    "textEmpty": "Нет активов",
    "topBar": {
      "allAssets": "Все активы",
      "assetSelected": "Выбран 1 актив",
      "assetsSelected": "Выбрано {{count}} активов",
      "results": "{{count}} результатов"
    },
    "change": "Изменить",
    "routines": "Рутины",
    "routineSearchPlaceholder": "Поиск названия рутины",
    "addonsSearchPlaceholder": "Поиск названия дополнения"
  },
  "products": {
    "textEmpty": "Нет продуктов",
    "list": {
      "name": "Название"
    }
  },
  "avatar": {
    "menu": {
      "profile": "Профиль"
    }
  },
  "binaryCheck": {
    "button": "Обновить",
    "instructions1": "Доступно новое обновление!",
    "instructions2": "Gripp может не работать до обновления."
  },
  "camera": {
    "Cancel": "Отмена",
    "grippInviteDetected": "Обнаружено приглашение Gripp!",
    "grippTagDetected": "Обнаружен тег Gripp!",
    "noCameraAccess": "Нет доступа к камере",
    "notGrippInvite": "Не приглашение Gripp",
    "notGrippTagg": "Не тег Gripp",
    "tryAgain": "Пожалуйста, попробуйте снова",
    "noPermissionModal": {
      "oopsMessage": "Упс! У вас нет разрешения на\nдоступ к этому тегу Gripp. 🙈",
      "button": "Понятно!",
      "errorMessage": "Если вы считаете, что это ошибка, подтвердите, что\nвы приглашены в правильное рабочее пространство или\nсвяжитесь со службой поддержки Gripp."
    }
  },
  "changesSaved": "Изменения сохранены",
  "common": {
    "back": "Назад",
    "cancel": "Отмена",
    "ok": "ОК",
    "close": "Закрыть",
    "create": "Создать",
    "download": "Загрузить",
    "reset": "Сбросить",
    "apply": "Применить",
    "save": "Сохранить",
    "optional": "Необязательно",
    "value": "Значение",
    "delete": "Удалить",
    "confirmDelete": "Удалить {{name}}",
    "deleteWarning": "Это действие нельзя отменить.",
    "next": "Далее",
    "remove": "Удалить",
    "typeMessage": "Введите сообщение...",
    "message": "Сообщение",
    "filter": "Фильтр",
    "searchOrCreate": "Найти или создать",
    "filterSearch": {
      "placeholder": "Поиск фильтров",
      "noResults": "Нет фильтров по запросу «{{query}}»"
    },
    "groupAssignments": "Назначения групп"
  },
  "customAlert": {
    "ok": "OK"
  },
  "deleteAccount": {
    "button": "Удалить аккаунт",
    "cannotUndone": "Это действие нельзя отменить.",
    "confirm": "Подтвердить удаление",
    "header": "Удалить аккаунт",
    "reasonInput": "Пожалуйста, сообщите нам любые дополнительные детали для удаления вашего аккаунта (необязательно):",
    "reasonInputNoOptional": "Пожалуйста, сообщите нам любые дополнительные детали для удаления вашего аккаунта:",
    "submitted": "Ваш запрос на удаление аккаунта был отправлен."
  },
  "dropdown": {
    "dropdownFooter": {
      "apply": "Применить",
      "reset": "Сбросить"
    }
  },
  "edit": "",
  "email": "Электронная почта",
  "features": {
    "title": "Функции",
    "assignment": {
      "workspaces": "Рабочие пространства",
      "accounts": "Аккаунты",
      "workspaceSearchPlaceholder": "Поиск рабочих пространств...",
      "accountSearchPlaceholder": "Поиск аккаунтов...",
      "noWorkspaces": "Рабочие пространства не найдены",
      "noAccounts": "Аккаунты не найдены",
      "name": "Имя",
      "email": "Электронная почта",
      "phone": "Телефон"
    }
  },
  "campaigns": {
    "menu": {
      "title": "Кампании"
    },
    "page": {
      "title": "Кампании"
    },
    "list": {
      "empty": "Кампании не найдены",
      "addCampaign": "Создать кампанию"
    },
    "columns": {
      "name": "Имя",
      "status": "Статус",
      "responses": "Ответы",
      "groups": "Группы",
      "products": "Продукты",
      "serialNumber": "Серийный номер",
      "lastUpdated": "Последнее обновление",
      "createdAt": "Создано в"
    },
    "create": {
      "panelTitle": "Новая кампания"
    },
    "responses": {
      "panelTitle": "Ответы"
    },
    "edit": {
      "panelTitle": "Редактировать кампанию"
    }
  },
  "firstName": "Имя",
  "forbidden": "Запрещено",
  "groups": {
    "groupsSelector": {
      "addToGroup": "Добавить в группу",
      "addtoNewGroup": "Добавить в новую группу",
      "apply": "Применить",
      "clearGroups": "Очистить группы"
    },
    "searchGroups": "Поиск групп",
    "noGroups": "Нет групп",
    "menu": {
      "title": "Группы",
      "editGroup": "Редактировать группу"
    },
    "create": {
      "label": "Создать новую группу",
      "validation": {
        "name_required": "Требуется название группы"
      },
      "create": "Создать",
      "placeholder": "например, Группа тракторов"
    },
    "list": {
      "name": "Название группы",
      "people": "Люди",
      "assets": "Активы",
      "reports": "Активные отчеты",
      "routines": "Рутины",
      "assetAlerts": "Оповещения Активов",
      "groupAlerts": "Оповещения Группы"
    },
    "common": {
      "textEmpty": "Нет группы",
      "selectGroup": "Выбрать группы",
      "searchGroup": "Поиск групп",
      "createGroup": "Создать группу",
      "emptyStateMessage": "Создайте группу, введя название прямо в строке поиска."
    },
    "filter": {
      "searchPlaceholder": "Поиск названий групп",
      "columnButton": "Столбцы",
      "columns": {
        "name": "Название группы",
        "reports": "Активные отчеты",
        "assets": "Активы",
        "people": "Люди",
        "routines": "Рутины",
        "assetAlerts": "Оповещения Активов",
        "groupAlerts": "Оповещения Группы"
      },
      "columnSelection": "Столбцы"
    },
    "assignments": {
      "name": "Имя",
      "jobTitle": "Должность",
      "accountType": "Тип аккаунта",
      "assetSearchPlaceholder": "Поиск названия актива, описания или названия группы",
      "accountSearchPlaceholder": "Поиск имени или должности человека",
      "routineSearchPlaceholder": "Поиск названия рутины",
      "groupSearchPlaceholder": "Поиск названий групп",
      "addonsSearchPlaceholder": "Поиск названия дополнения",
      "emptyAccountList": "Нет аккаунтов",
      "assets": "Активы",
      "groups": "Группы",
      "people": "Люди",
      "routines": "Рутины"
    },
    "deleteGroup": {
      "deleteGroup": "Удалить группу",
      "alertBody1": "Вы уверены, что хотите удалить",
      "alertBody2": "Примечание: ",
      "alertBody3": "Это не удалит активы, связанные с этой ",
      "alertBody4": "группой.",
      "delete": "Удалить",
      "cancel": "Отмена",
      "toastTitle": "Готово!",
      "toastMessage": "{{groupName}} удалён."
    }
  },
  "help": {
    "menu": {
      "title": "Помощь"
    }
  },
  "alertsManagement": {
    "menu": {
      "title": "Оповещения",
      "editAlert": "Редактировать оповещение"
    },
    "filter": {
      "searchPlaceholder": "Поиск оповещений...",
      "columnButton": "Столбцы",
      "statusButton": "Статус",
      "columnSelection": "Выбор столбцов",
      "columns": {
        "name": "Название",
        "routineName": "Рутина",
        "assetName": "Актив",
        "groupName": "Группа",
        "productName": "Продукт",
        "assetAlerts": "Оповещения активов",
        "lastAlertDate": "Последнее оповещение",
        "nextAlertDate": "Следующее оповещение",
        "createdAt": "Создано",
        "status": "Статус"
      },
      "status": {
        "label": "Статус",
        "all": "Все",
        "enabled": "Включено",
        "disabled": "Отключено"
      }
    },
    "common": {
      "textEmpty": "Оповещения не найдены"
    },
    "list": {
      "name": "Название",
      "routineName": "Рутина",
      "assetName": "Актив",
      "groupName": "Группа",
      "productName": "Продукт",
      "assetAlerts": "Оповещения активов",
      "lastAlertDate": "Последнее оповещение",
      "nextAlertDate": "Следующее оповещение",
      "createdAt": "Создано",
      "status": "Статус"
    },
    "deleteAlert": {
      "deleteAlert": "Удалить оповещение",
      "alertBody1": "Вы уверены, что хотите удалить",
      "alertBody2": "Предупреждение:",
      "alertBody3": " Удаление этого оповещения безвозвратно удалит его вместе со всеми связанными данными.",
      "delete": "Удалить",
      "cancel": "Отмена"
    },
    "actions": {
      "enable": "Включить",
      "disable": "Отключить",
      "enableSuccess": "Успешно включено {count} оповещение(й)",
      "disableSuccess": "Успешно отключено {count} оповещение(й)"
    }
  },
  "invitation": {
    "initial": {
      "heading": "Вас пригласили в {{workspaceName}}!",
      "login": "Ключ входа",
      "step1": "Шаг 1",
      "step1Instructions": "Скачайте приложение Gripp",
      "step2": "Шаг 2",
      "step2Instructions": "Используйте этот ключ для входа"
    },
    "invitePeople": {
      "copiedInvitationLink": "Ссылка приглашения скопирована",
      "copyInviteLink": "Копировать ссылку приглашения",
      "shareInviteLink": "Поделиться ссылкой приглашения",
      "errorCopyingInvitationLink": "Что-то пошло не так при копировании ссылки приглашения",
      "invitePeopleForm": "Пригласить людей по email",
      "invitePeopleQR": "Пригласить людей через QR-код",
      "linkAllowsToJoinWorkplace": "Эта ссылка позволяет любому запросить присоединение к вашему рабочему пространству.",
      "emailPlaceholder": "Email",
      "inviteViaEmailLabel": "Пригласить по Email",
      "inviteSentSuccess": "Приглашение успешно отправлено",
      "inviteSentError": "Что-то пошло не так при отправке приглашения",
      "placeholder": "Email адреса",
      "send": "Отправить",
      "submit": "Отправить",
      "to": "Кому"
    },
    "pending": {
      "accepted": "Перейдите по ссылке, отправленной на ваш email, чтобы войти в ваш аккаунт Gripp.",
      "cancel": "Отмена",
      "join": "Присоединиться",
      "joining": "Вы присоединяетесь к {{workspaceName}}",
      "title": "Создать профиль"
    },
    "qr": {
      "invitesYou": "приглашает вас присоединиться",
      "showQr": "Показать QR для приглашения других"
    }
  },
  "issue": {
    "anonymous": {
      "addNote": "Добавить заметку",
      "createReport": "Создать отчет",
      "getGrippCta": "Установите Gripp, чтобы видеть активность, файлы и присоединиться к беседе!",
      "noteAdded": "Заметка добавлена!",
      "noteAddedDownloadGrippApp": "Скачайте приложение Gripp для еще более удобного ведения заметок!",
      "openAppStore": "Открыть App Store",
      "report": "Отчет",
      "reportAddedDownloadGrippApp": "Скачайте приложение Gripp для еще более быстрой отчетности!",
      "reported": "Проблема сообщена!",
      "routineCompleted": "Готово, обновление подтверждено!",
      "routineCompletedDownloadGrippApp": "Скачайте приложение Gripp для наилучшего опыта!",
      "dropRoutineTitle": "Готово.",
      "dropRoutineSubtitle": "Продолжайте в Gripp для более быстрого сканирования, отчётности и просмотра истории.",
      "dropReportTitle": "Будьте в курсе.",
      "dropReportSubtitle": "Продолжайте в Gripp, чтобы видеть ответы, добавлять заметки и получать больше информации.",
      "dropCta": "Скачать приложение",
      "dropCtaA11yLabel": "Скачать приложение Gripp"
    },
    "common": {
      "addPicture": "Фотографии",
      "addMedia": "Фото и видео",
      "description": "Описание",
      "followUp": "Требуется последующее действие?",
      "note": "Нет, просто заметка для справки",
      "report": "Да, требуется последующее действие",
      "addLabel": "Добавить метку",
      "labelSubtitle": "Для более удобного поиска и фильтрации.",
      "selectLabel": "Выбрать метку",
      "searchLabel": "Поиск метки",
      "createLabel": "Создать метку",
      "emptyStateMessage": "Создайте метку, введя название прямо в строке поиска.",
      "labelsApplied": "Метки применены"
    },
    "delete": {
      "confirm": "Подтвердить удаление?",
      "button": "Удалить Issue",
      "warning": "Это действие нельзя отменить.",
      "cancel": "Отмена",
      "title": "Удалить Активность"
    },
    "editModal": {
      "header": "Редактировать",
      "save": "Сохранить",
      "reviseSubmission": "Пересмотреть отправку",
      "pinDescription": "Закрепленная активность отображается в деталях актива"
    },
    "accessRequest": {
      "workspaceAccessRequest": "Запрос доступа к рабочему пространству: {{message}}",
      "requestingFullAccess": "Запрос полного доступа к рабочему пространству.",
      "approve": "Одобрить",
      "deny": "Отклонить",
      "approveA11y": "Одобрить запрос доступа",
      "denyA11y": "Отклонить запрос доступа"
    },
    "message": {
      "anonymousGuestOf": "Анонимно (гость {{sharer}})",
      "anonymousGuestSignInA11y": "Войдите, чтобы присвоить это сообщение"
    },
    "latestMessage": {
      "media": "[Медиа]"
    },
    "menu": {
      "delete": "Удалить",
      "edit": "Редактировать",
      "editRoutine": "Редактировать рутину",
      "pinToAsset": "Закрепить на активе",
      "print": "Печать",
      "reassign": "Переназначить",
      "reminder": "Напоминание",
      "unpin": "Открепить",
      "unpinToAsset": "Открепить от актива"
    },
    "new": {
      "addIt": "Добавить отчет / заметку",
      "editActivity": "Редактировать активность",
      "labels": "Метки",
      "optionalPlaceholder": "Необязательно",
      "placeholder": "Что вы видите?",
      "reassign": "Переназначить",
      "reminder": "Напоминание",
      "submit": "Отправить",
      "title": "Заголовок",
      "type": "Тип"
    },
    "quickReminder": {
      "header": "Установить напоминание",
      "subheader": "Чтобы запланировать этот отчет на будущую дату."
    },
    "adjustCreationDate": {
      "header": "Изменить дату создания"
    },
    "createdDate": {
      "header": "Дата создания"
    },
    "types": {
      "attention": "Срочно",
      "urgent": "Срочно",
      "blocker": "В ожидании",
      "pending": "В ожидании",
      "done": "Решено",
      "solved": "Решено",
      "routines": "Рутины",
      "note": "Заметка",
      "campaign": "Кампания"
    },
    "advancedSettings": "Расширенные настройки",
    "dateFormat": "ДД/ММ/ГГГГ",
    "reminderFor": "Напоминание для:",
    "reminderDate": "Дата напоминания",
    "reminderTime": "Время напоминания",
    "reassign": {
      "instructions": "К какому из следующих активов вы хотите переназначить?",
      "placeholder": "Поиск названия актива",
      "saveLabel": "Сохранить",
      "title": "Переназначить",
      "unassigned": "{{workspace}} (Не назначено)"
    },
    "topBar": {
      "allReplies": "ответов"
    },
    "reminder": {
      "notesOptional": "Заметки (необязательно)",
      "scheduled": "Запланированное напоминание"
    },
    "location": {
      "deniedTitle": "Нужен доступ к геолокации",
      "deniedMessage": "Разрешите Gripp доступ к геолокации в настройках устройства, чтобы поделиться своим местоположением.",
      "unavailableTitle": "Не удалось определить местоположение",
      "unavailableMessage": "Сейчас не удалось определить позицию. Переместитесь туда, где сигнал лучше, и повторите попытку."
    }
  },
  "job": "",
  "jobTitle": "Должность",
  "lastName": "Фамилия",
  "loading": "Загрузка",
  "login": {
    "codeSentTo": "Код входа отправлен на",
    "email": "Электронная почта",
    "error": {
      "invalidCredentials": "Неверные учетные данные",
      "processError": "Произошла ошибка при обработке вашего запроса"
    },
    "login": "Войти",
    "password": "Пароль",
    "resendCode": "Отправить код повторно",
    "tabs": {
      "new": {},
      "returning": {
        "title": "Я возвращаюсь"
      }
    },
    "tryAnotherMethod": "Попробовать другой способ",
    "withEmail": "Продолжить с Email",
    "withPassword": "У меня есть пароль",
    "withPhone": "Продолжить с телефоном",
    "continue": "Продолжить",
    "skip": "Пропустить",
    "verify": "Подтвердить",
    "didntReceiveCode": "Не получили код?",
    "welcome": "Добро пожаловать",
    "signUpToContinue": "Зарегистрируйтесь, чтобы продолжить",
    "orUsePrefix": "или использовать",
    "toggleEmail": "email",
    "togglePhone": "телефон",
    "smsConfirmationMessage": "Мы отправим SMS для подтверждения вашего номера. Это может занять несколько секунд.",
    "emailConfirmationMessage": "Мы отправим код подтверждения на ваш email. Это может занять несколько секунд.",
    "verifyCodeSentTo": "Код отправлен на",
    "aboutYourself": "Расскажите нам о себе!",
    "existingAccount": "Уже есть аккаунт Gripp?"
  },
  "logout": "Выйти",
  "errorBoundary": {
    "title": "Упс!",
    "message": "Произошла непредвиденная ошибка.",
    "tryAgain": "Попробовать снова"
  },
  "mentions": {
    "unknownUser": "Неизвестный пользователь",
    "youAreMentioned": "Вас упомянули"
  },
  "media": {
    "validation": {
      "unsupported": "Не удалось загрузить этот файл. Возможно, он повреждён или имеет неподдерживаемый формат."
    }
  },
  "modalMessages": {
    "completed": "Завершено"
  },
  "or": "или",
  "onboarding": {
    "shareInfo": "Расскажите Gripp больше о себе!",
    "industrial": "Промышленная сфера",
    "source": "Как вы узнали о Gripp?",
    "agriculture": "Сельское хозяйство"
  },
  "people": {
    "menu": {
      "people": "Люди"
    }
  },
  "phone": "Номер телефона",
  "plusMenu": {
    "add-asset": "Добавить актив",
    "invite": "Пригласить",
    "no-tag": "Нет тега?",
    "note": "Заметка",
    "report": "Отчет",
    "scan": "Сканировать"
  },
  "preferences": {
    "appearance": {
      "title": "Тема",
      "system": "Системная",
      "systemDescription": "Следовать настройке операционной системы.",
      "light": "Светлая",
      "lightDescription": "Стандартная палитра Crop Circle.",
      "dark": "Тёмная",
      "darkDescription": "Палитра для слабого освещения, снижающая нагрузку на глаза.",
      "more": "Дополнительно",
      "moreComingSoon": "Настройки размера шрифта, плотности и уменьшения движения появятся позже."
    },
    "language": {
      "languages": {
        "english": "Английский",
        "spanish": "Испанский",
        "russian": "Русский",
        "kazakh": "Казахский",
        "afrikaans": "Африкаанс",
        "portuguese": "Португальский",
        "french": "Французский"
      },
      "language": "Язык",
      "preferredLanguageTitle": "Предпочитаемый язык"
    },
    "menu": {
      "title": "Настройки"
    },
    "settings": {
      "appearance": "Внешний вид",
      "notifications": "Уведомления",
      "permissions": "Разрешения",
      "profile": "Профиль",
      "title": "Настройки",
      "workSpaces": "Рабочие пространства",
      "workspace_settings": "Настройки рабочих пространств"
    },
    "permissions": {
      "title": "Разрешения",
      "allow": "Разрешить",
      "location": {
        "label": "Службы геолокации",
        "description": "Gripp использует геолокацию вашего телефона для обновления местоположения ваших активов при их сканировании. Как минимум, мы просим разрешить геолокацию во время использования приложения."
      },
      "camera": {
        "label": "Доступ к камере",
        "description": "Создание заметок и сообщений о проблемах часто требует фотографирования того, что вы видите, поэтому включение доступа к камере важно для поддержания актуальности информации."
      },
      "gallery": {
        "label": "Доступ к фотобиблиотеке",
        "description": "Как и в случае с камерой, иногда у вас уже есть фотографии, которые вы хотите загрузить в Gripp. У нас будет доступ только к тем фотографиям, которые вы выберете при загрузке."
      },
      "pushNotifications": {
        "label": "Push-уведомления",
        "description": "Как и многие приложения, получайте уведомления о новых тревогах, проблемах или отчётах. Вы не захотите пропустить ничего важного."
      },
      "feature": {
        "scanner": "Доступ к камере необходим для сканирования QR-кодов и добавления фотографий к заметкам и отчётам.",
        "gallery": "Доступ к фотобиблиотеке необходим для загрузки изображений из вашей галереи в заметки и отчёты."
      }
    },
    "notifications": {
      "activityLabelNotificationsTitle": "Уведомления по меткам активности",
      "groupNotificationsTitle": "Уведомления группы",
      "campaignMessages": "Новые кампании",
      "issueReplies": "Сообщения",
      "notificationTitle": "Уведомления",
      "schedule": {
        "accept": "Принять",
        "cancel": "Отмена",
        "endTime": "Время окончания:",
        "everyDay": "Каждый день",
        "notSet": "Не установлено",
        "notificationSchedule": "Расписание уведомлений",
        "set": "Установить",
        "startTime": "Время начала:",
        "weekDays": "Будние дни"
      },
      "severities": {
        "blue": "Новые рутины",
        "purple": "Новые заметки",
        "red": "Новые отчеты"
      }
    }
  },
  "profile": {
    "edit": {
      "menu": {
        "title": "Редактировать профиль"
      },
      "impersonate": {
        "impersonate": "Войти как",
        "unimpersonate": "Отменить вход как"
      },
      "error": {
        "title": "Ошибка при обновлении профиля",
        "generic": "Что-то пошло не так при обновлении вашего профиля. Пожалуйста, попробуйте еще раз.",
        "duplicatedPhone": "Этот номер телефона уже связан с другой учетной записью."
      }
    },
    "admin": {
      "title": "Имперсонация",
      "workspace": "Рабочее пространство",
      "workspaceUsers": "Пользователи рабочего пространства"
    }
  },
  "recent_activities": "Недавняя активность",
  "reminders": {
    "deleteReminder": "Удалить напоминание",
    "setNewReminder": "установить новое напоминание для"
  },
  "requestRoutine": {
    "apply": "Применить",
    "header": "Рутина",
    "instruction": "Пожалуйста, отправьте вашу идею рутины:",
    "placeHolder": "Что нам следует начать делать?"
  },
  "routines": {
    "admin": {
      "create": "Сохранить",
      "instructions": "Инструкции",
      "issuePrefix": "Префикс проблемы",
      "reportOnException": "Отчет об исключении?",
      "routineButtonText": "Кнопка рутины",
      "title": "Заголовок",
      "type": "Тип",
      "oneTimeOnly": "Только один раз",
      "autoPrompt": "Автоматический запрос при открытии актива",
      "idpEnabled": "Включить отправку IDP",
      "idpDocumentDescription": "Опишите документ для извлечения ИИ",
      "idpDocumentDescriptionHint": "Необязательно. Скрыто от операторов — сообщает ИИ, какой документ он читает, прежде чем искать отдельные поля.",
      "isWorkspaceRoutine": "Рабочая процедура",
      "workspaceRoutineBadge": "Рабочая область",
      "update": "Обновить",
      "addMedia": "Добавить медиа",
      "image": "Изображение",
      "video": "Видео",
      "link": "Ссылка",
      "linkLabel": "Добавить ссылку",
      "linkUrl": "URL ссылки",
      "linkUrlPlaceholder": "Введите URL (например, https://example.com)",
      "invalidUrl": "Неверный URL",
      "removeMedia": "Удалить медиа",
      "enableAutoPinning": "Включить автоматическую фиксацию",
      "autoAddLabel": "Автоматически добавить метку"
    },
    "assign": "Назначить рутины",
    "copyToWorkspace": {
      "save": "Копировать",
      "title": "Копировать в рабочее пространство",
      "workspace": "Рабочее пространство"
    },
    "counter": {
      "admin": {
        "decimalPlaces": "Включить десятичные (необязательно)",
        "tallyCounter": "Счетчик подсчета",
        "uom": "Единица измерения",
        "counterType": "Тип счетчика"
      },
      "user": {
        "integrationManaged": "Управляется {{provider}} — обновляется автоматически",
        "genericCounter": {
          "change": "Изменить:",
          "initialValue": "Начальное значение:",
          "newValue": "Новое значение:"
        },
        "tallyCounter": {
          "add": "+ Добавить",
          "added": "Добавлено",
          "adding": "Добавление:",
          "instructions": "",
          "newValue": "Новое значение:",
          "oldValue": "Старое значение:",
          "placeholder": "Введите число...",
          "remove": "- Удалить",
          "removed": "Удалено",
          "removing": "Удаление:"
        }
      },
      "counterTypes": {
        "SIMPLE": "Простой",
        "CUMULATIVE": "Накопительный",
        "TALLY": "Подсчет"
      }
    },
    "time": {
      "admin": {
        "time": "Тип времени",
        "labelStartTime": "Время начала",
        "labelEndTime": "Время окончания"
      },
      "timeTypes": {
        "START_END_TIMES": "Время начала и окончания",
        "TIME_ONLY": "Только время",
        "DATE_ONLY": "Только дата",
        "TIME_AND_DATE": "Дата и время"
      },
      "message": {
        "time": "Время",
        "start": "Начало",
        "end": "Конец",
        "date": "Дата"
      }
    },
    "download": {
      "noDataTitle": "Нечего загружать",
      "noDataMessage": "У выбранных рутин нет данных за выбранные даты."
    },
    "createNew": "Создать рутину",
    "edit": {
      "header": "Рутины > Редактировать рутину",
      "title": "Редактировать рутину"
    },
    "editRoutines": {
      "editRoutinesButton": "Редактировать рутины",
      "label": "Метка: ",
      "routineInWorkplace": "Все рутины, доступные в вашем рабочем пространстве",
      "title": "Редактировать",
      "saveSuccess": "Рутины успешно обновлены",
      "saveError": "Не удалось сохранить рутины",
      "routineAdded": "Рутина {{title}} была добавлена",
      "routineRemoved": "Рутина {{title}} была удалена",
      "routineReordered": "Рутины успешно переупорядочены"
    },
    "exceptions": {
      "addDetails": "Пожалуйста, добавьте дополнительные детали или фотографии проблемы:",
      "exceptionsNoticed": "Замечено {{count}} исключение",
      "exceptionsNoticed_plural": "Замечено {{count}} исключений",
      "reportCreated": "Отчет создан",
      "viewRelatedReport": "Просмотреть связанный отчет",
      "viewRelatedRoutine": "Просмотреть связанную рутину"
    },
    "header": {
      "title": "Рутины",
      "view": "Просмотр",
      "viewAll": "Просмотреть все"
    },
    "menu": {
      "copyToWorkspace": "Копировать в рабочее пространство",
      "delete": {
        "cancel": "Отмена",
        "confirm": "Да",
        "item": "Удалить",
        "title": "Вы уверены, что хотите удалить эту рутину?",
        "blockedTitle": "Рутина используется",
        "blockedGeneric": "Не удалось удалить эту рутину. Пожалуйста, попробуйте ещё раз."
      },
      "download": "Загрузить",
      "editRoutine": "Редактировать рутину",
      "export": "Экспорт данных",
      "exporting": "Экспорт..."
    },
    "message": {
      "messageTitle": "{{name}} завершил рутину:",
      "added": "добавлено",
      "removed": "удалено",
      "originalValue": "Исходное значение",
      "newValue": "Новое значение",
      "messageTitleUpdated": "{{name}} внес обновление",
      "idp": {
        "extracting": "Извлечение…",
        "takingLonger": "Извлечение ИИ занимает больше времени, чем ожидалось.",
        "editLocked": "Извлечение ИИ выполняется — эту заявку нельзя редактировать, пока оно не завершится."
      }
    },
    "modalCancel": {
      "primary": "Выйти без сохранения.",
      "secondary": "Отмена",
      "title": "Перед возвратом,"
    },
    "draftModal": {
      "continueDraft": "Продолжить черновик.",
      "startNew": "Начать новую рутину.",
      "cancel": "Отмена",
      "messageNoDraft": "Черновик сохранен",
      "messageWithoutCreator": "Черновик сохранен {{date}}",
      "messageWithCreator": "Черновик сохранен: \n{{creator}} {{date}}"
    },
    "new": {
      "chooseTypeButton": "Следующий шаг: Выбрать опции",
      "header": "Рутины > Создать рутину",
      "title": "Создать рутину"
    },
    "quickConfirm": {
      "admin": {
        "addOption": "Добавить опцию",
        "options": "Опции"
      }
    },
    "requestButton": "+ Запросить рутину",
    "signature": {
      "clear": "Очистить",
      "done": "Готово",
      "sign": "Подписать",
      "signature": "Подпись",
      "submit": "Отправить"
    },
    "status": {
      "admin": {
        "addStatus": "Добавить статус",
        "statuses": "Статусы",
        "openEndedResponse": "Открытый ответ",
        "otherStatus": "Другое _______"
      }
    },
    "submit": "Отправить",
    "resubmit": "Отправить повторно",
    "saveDraft": "Сохранить как черновик",
    "types": {
      "COUNTER": "Счетчик",
      "QUICK_CONFIRM": "Быстрое подтверждение",
      "STATUS": "Статус",
      "WORKFLOW": "Мини-форма"
    },
    "update": "Обновить",
    "workflow": {
      "admin": {
        "page": {
          "addQuestion": "Добавить вопрос",
          "duplicateQuestion": "Дублировать вопрос",
          "instructions": "Инструкции",
          "page": "Страница {{page}}",
          "questionType": "Тип вопроса",
          "deleteQuestion": "Удалить вопрос"
        },
        "question": {
          "addOption": "Добавить опцию",
          "exception": {
            "HasResponse": "Есть ответ",
            "MissingResponse": "Отсутствует ответ",
            "Off": "Выключено",
            "label": "Обработка исключений:"
          },
          "instructions": "Инструкции",
          "multiline": "Многострочный",
          "options": "Опции",
          "question": "Вопрос {{question}}",
          "barcodeScanner": {
            "allowMultiple": "Разрешить несколько записей",
            "includeQuantity": "Включить поле количества",
            "includeMemo": "Добавить поле заметки"
          },
          "location": {
            "includeMemo": "Добавить поле заметки"
          },
          "idpSource": "Документ IDP — закреплён",
          "idpSourceInstructions": "Сфотографируйте или загрузите документ, из которого нужно извлечь данные.",
          "idpSourceImageOnly": "Заблокировано, пока IDP включён — принимает только изображения, видео не поддерживается.",
          "idpManaged": "Управляется через IDP",
          "idpPrompt": "Опишите это поле для извлечения ИИ",
          "idpPromptHint": "Скрыто от операторов — заполняется автоматически из документа.",
          "idpPromptRequired": "Для полей, управляемых ИИ, требуется подсказка.",
          "idpManagedCapReached": "Достигнут предел в 100 полей, управляемых IDP."
        },
        "routine": {
          "label": "Рутина",
          "select": "Выбрать рутину"
        }
      },
      "execution": {
        "optional": "Необязательно",
        "submit": "Отправить",
        "barcodeScanner": {
          "addAnother": "Добавить ещё:",
          "placeholder": "Введите или отсканируйте штрих-код",
          "placeholderManual": "Введите штрих-код",
          "quantityPlaceholder": "Кол-во",
          "quantityLabel": "Кол-во: {{quantity}}",
          "remove": "Удалить запись",
          "scan": "Сканировать штрих-код",
          "memoPlaceholder": "Заметка"
        },
        "location": {
          "placeholder": "Нажмите для захвата местоположения",
          "captureLabel": "Захватить текущее местоположение",
          "memoPlaceholder": "Добавить заметку..."
        },
        "media": {
          "idpImageRequired": "Для извлечения ИИ требуется как минимум одно изображение."
        }
      },
      "questionTypes": {
        "CHECKBOX": "Множественный выбор",
        "COUNTER": "Счетчик",
        "MEDIA": "Медиа",
        "QUICK_CONFIRM": "Быстрое подтверждение",
        "RADIO": "Одиночный выбор",
        "ROUTINE": "Рутина",
        "SIGNATURE": "Подпись",
        "STATUS": "Статус",
        "TEXT": "Текст",
        "TIME": "Время",
        "LABEL": "Метка",
        "BARCODE_SCANNER": "Сканер штрих-кода",
        "LOCATION": "Местоположение"
      }
    },
    "textEmpty": "Нет рутин",
    "addToGroups": "Добавить в группы",
    "addToGroupsDescription": "Назначить {{count}} выбранных рутин группам",
    "list": {
      "name": "Название",
      "type": "Тип",
      "groups": "Группы"
    }
  },
  "saveChanges": "Сохранить изменения",
  "unsavedChanges": {
    "title": "Несохранённые изменения",
    "subtitle": "Хотите сохранить прогресс перед продолжением?",
    "saveAndExit": "Сохранить и выйти",
    "dontSave": "Не сохранять"
  },
  "signOut": "Выйти",
  "support": {
    "genericDescription": "Иногда случаются сбои, но если вы снова увидите эту страницу, пожалуйста, сообщите нам, чтобы мы могли все исправить!",
    "sendEmail": "Или напишите мне на",
    "title": "Упс, мы ошиблись"
  },
  "tags": {
    "assetName": "Название актива",
    "batches": {
      "title": "Заказы"
    },
    "status": "Статус",
    "tagCode": "Номер тега",
    "title": "Теги",
    "updatedAt": "Обновлено",
    "version": "Версия"
  },
  "textEmptyList": "Нет данных",
  "topNav": {
    "activities": "Активность",
    "add": "Добавить",
    "assetInfo": "Просмотр актива",
    "assets": "Активы",
    "back": "Назад",
    "backButton": {
      "cancel": "Продолжить редактирование",
      "confirmBack": "Есть несохраненные изменения!",
      "ok": "Выйти без сохранения"
    },
    "cancel": "Отмена",
    "customAlert": {
      "cancel": "Отмена",
      "deleteAccount": "Вы уверены, что хотите удалить свой аккаунт?",
      "exit": "Выйти без сохранения?",
      "signOut": "Вы уверены, что хотите выйти?",
      "yes": "Да",
      "saveProgress": "Сохранить на потом."
    },
    "edit": "Редактировать",
    "editAsset": "Информация об активе",
    "invite": "Пригласить людей",
    "moreAssetInfo": "Дополнительная информация об активе",
    "moreWorkspaceInfo": "Дополнительная информация о рабочем пространстве",
    "save": "Сохранить",
    "myHistory": "Моя история",
    "modify": "Изменить"
  },
  "translation": {
    "seeOriginal": "Смотреть оригинал",
    "seeTranslation": "Смотреть перевод"
  },
  "versionCheck": {
    "description": "Доступны обновления! Некоторые функции могут не работать, пока вы не обновите браузер.",
    "refreshButton": "Обновить"
  },
  "offline": {
    "banner": {
      "title": "Вы не в сети"
    }
  },
  "workspace": {
    "editTitle": "Информация о рабочем пространстве",
    "titleSingular": "Рабочее пространство",
    "filter": {
      "searchPlaceholder": "Поиск по названию",
      "columnButton": "Столбцы",
      "tierButton": "Подписка",
      "columnSelection": "Столбцы",
      "tierSelection": "Подписка",
      "typeSelection": "Тип",
      "columns": {
        "name": "Название",
        "owner": "Администратор",
        "type": "Тип",
        "subscriptionTierId": "Подписка",
        "assetsCount": "Активы",
        "routinesCount": "Рутины",
        "alerts": "Оповещения",
        "peopleCount": "Люди",
        "activitiesCount": "Активности",
        "groupsCount": "Группы",
        "createdAt": "Создано",
        "createdDate": "Дата создания",
        "createdTime": "Время создания",
        "createdBy": "Создано",
        "lastScanned": "Последнее сканирование",
        "lastScannedDate": "Дата последнего сканирования",
        "lastScannedTime": "Время последнего сканирования",
        "updatedAt": "Последнее обновление",
        "updatedDate": "Дата последнего обновления",
        "updatedTime": "Время последнего обновления",
        "lastActivity": "Последняя активность",
        "lastActivityDate": "Дата последней активности",
        "lastActivityTime": "Время последней активности"
      }
    },
    "types": {
      "PRODUCER": "Производитель",
      "OEM": "OEM"
    },
    "create": {
      "addButton": "Отправить",
      "administratorEmail": "Email администратора",
      "administratorPhone": "Номер телефона администратора",
      "administratorFirstName": "Имя администратора",
      "administratorLastName": "Фамилия администратора",
      "copyRoutines": "Копировать рутины",
      "title": "Создать рабочее пространство",
      "validation": {
        "admin_email_required": "Требуется email администратора",
        "admin_first_name_required": "Требуется имя администратора",
        "admin_last_name_required": "Требуется фамилия администратора",
        "name_required": "Требуется название рабочего пространства",
        "valid_emil": "Email администратора должен быть действительным адресом электронной почты"
      },
      "type": "Тип",
      "workspaceName": "Название рабочего пространства",
      "name": "Название рабочего пространства"
    },
    "createButton": "Создать рабочее пространство",
    "menu": {
      "editWorkspace": "Редактировать рабочее пространство",
      "duplicateWorkspace": "Дублировать рабочее пространство"
    },
    "duplicate": {
      "title": "Дублировать рабочее пространство",
      "sourceLabel": "Дублирование из",
      "contentToCopy": "Содержимое для копирования",
      "activities": "Активности",
      "assets": "Активы",
      "routines": "Рутины",
      "people": "Люди",
      "alerts": "Оповещения",
      "groups": "Группы",
      "duplicateButton": "Дублировать рабочее пространство"
    },
    "deleteWorkspace": {
      "deleteWorkspace": "Удалить рабочее пространство",
      "alertBody1": "Вы уверены, что хотите удалить",
      "alertBody2": "Примечание: ",
      "alertBody3": "Это не удалит активы, связанные с этим ",
      "alertBody4": "рабочим пространством.",
      "delete": "Удалить",
      "cancel": "Отмена"
    },
    "list": {
      "name": "Название",
      "owner": "Администратор",
      "type": "Тип",
      "assetsCount": "Активы",
      "routinesCount": "Рутины",
      "alerts": "Оповещения",
      "peopleCount": "Люди",
      "activitiesCount": "Активности",
      "groupsCount": "Группы",
      "createdAt": "Создано",
      "createdDate": "Дата создания",
      "createdTime": "Время создания",
      "createdBy": "Создано",
      "lastScanned": "Последнее сканирование",
      "lastScannedDate": "Дата последнего сканирования",
      "lastScannedTime": "Время последнего сканирования",
      "updatedAt": "Последнее обновление",
      "updatedDate": "Дата последнего обновления",
      "updatedTime": "Время последнего обновления",
      "lastActivity": "Последняя активность",
      "lastActivityDate": "Дата последней активности",
      "lastActivityTime": "Время последней активности"
    }
  },
  "permissions": {
    "backButton": "Назад",
    "continueButton": "Продолжить",
    "enableInSettings": "Вы должны включить это разрешение в системном меню, чтобы продолжить.",
    "openSetting": "Открыть настройки",
    "welcome": {
      "title": "Добро пожаловать в Gripp!",
      "description1": "Для использования Gripp нам нужно включить несколько разрешений.",
      "description2": "Мы проведем вас через каждое из них, чтобы объяснить, зачем оно нам нужно.",
      "description3": "Все настройки можно изменить в настройках вашего телефона в любое время."
    },
    "location": {
      "initial": {
        "title": "Доступ к вашему местоположению для отслеживания активов.",
        "description1": "Gripp использует местоположение вашего телефона для обновления местоположения ваших активов при их сканировании.",
        "description2": "Минимально мы просим разрешить доступ к местоположению при использовании приложения."
      },
      "denied": {
        "title": "Доступ к местоположению для отслеживания активов.",
        "description1": "Местоположение помогает отслеживать ваши активы."
      },
      "button": "Продолжить"
    },
    "camera": {
      "initial": {
        "title": "Доступ к камере для съемки, сообщений и отчетов.",
        "description1": "Ведение заметок и сообщение о проблемах часто требуют фотографирования того, что вы видите, поэтому включение доступа к камере важно для съемки!"
      },
      "denied": {
        "title": "Доступ к камере для съемки, сообщений и отчетов.",
        "description1": "Доступ к камере позволяет легко снимать и составлять отчеты!"
      },
      "button": "Продолжить"
    },
    "gallery": {
      "initial": {
        "title": "Доступ к галерее фотографий для загрузки изображений.",
        "description1": "Как и с камерой, иногда у вас уже есть фотографии, которые вы хотите загрузить в Gripp.",
        "description2": "Gripp будет иметь доступ только к фотографиям, которые вы выберете в момент загрузки."
      },
      "denied": {
        "title": "Доступ к галерее фотографий для загрузки изображений.",
        "description1": "Доступ к галерее позволяет загружать выбранные вами фотографии."
      },
      "button": "Продолжить"
    },
    "notification": {
      "initial": {
        "title": "Оставайтесь в курсе с уведомлениями.",
        "description1": "Получайте уведомления при поступлении нового оповещения, проблемы или отчета."
      },
      "denied": {
        "title": "Уведомления, чтобы оставаться в курсе.",
        "description1": "Получайте командные оповещения, проблемы и отчеты — без маркетинговых сообщений."
      },
      "button": "Продолжить"
    },
    "allSet": "Все готово, давайте начнем использовать Gripp!"
  },
  "routine": {
    "list": {
      "name": "Название",
      "type": "Тип рутины",
      "groups": "Группы",
      "routines": "Рутины",
      "oldRoutines": "Старые рутины",
      "asset": {
        "name": "Название",
        "description": "Описание",
        "groups": "Группы"
      }
    },
    "filter": {
      "searchPlaceholder": "Поиск названия рутины",
      "columnButton": "Столбцы",
      "columnSelection": "Столбцы",
      "columns": {
        "name": "Название",
        "type": "Тип рутины",
        "assetsCount": "Активы",
        "addonsCount": "Дополнения",
        "allAssetsCount": "Все активы",
        "submissionsCount": "Отправки",
        "groups": "Группы",
        "groupNames": "Названия групп",
        "lastSubmitted": "Последняя отправка",
        "updatedAt": "Последнее редактирование",
        "createdAt": "Дата создания",
        "workspace": "Рабочее пространство"
      }
    },
    "rowHeader": {
      "routineSelected": "Выбрана 1 рутина",
      "routinesSelected": "Выбрано {{count}} рутин"
    },
    "permittedRoles": {
      "label": "Разрешенные Роли",
      "noRoles": "Нет доступных ролей"
    }
  },
  "product": {
    "change": "Изменить",
    "list": {
      "products": "Продукты",
      "name": "Название",
      "description": "Описание",
      "assetsCount": "Активы",
      "filesCount": "Файлы",
      "addonsCount": "Дополнения",
      "routines": "Рутины",
      "alerts": "Оповещения активов",
      "productAlerts": "Оповещения продуктов",
      "createdAt": "Создано",
      "updatedAt": "Последнее обновление"
    },
    "filter": {
      "searchPlaceholder": "Поиск названия продукта",
      "columnButton": "Столбцы",
      "columns": {
        "name": "Название",
        "description": "Описание",
        "assetsCount": "Активы",
        "filesCount": "Файлы",
        "addonsCount": "Дополнения",
        "routines": "Рутины",
        "alerts": "Оповещения активов",
        "productAlerts": "Оповещения продуктов",
        "createdAt": "Создано",
        "updatedAt": "Последнее обновление"
      },
      "columnSelection": "Столбцы"
    },
    "create": {
      "label": "Создать новый продукт",
      "validation": {
        "name_required": "Требуется название продукта"
      },
      "cancel": "Отмена",
      "create": "Создать",
      "placeholder": "например, Продукт 1"
    },
    "delete": {
      "button": "Удалить продукт",
      "cancel": "Отмена",
      "confirm": "Да",
      "title": "Вы уверены, что хотите удалить продукт {{productName}}?"
    },
    "detail": {
      "addon_options": "Опции дополнений",
      "no_addon_options": "Для этого продукта нет опций дополнений.",
      "add_more": "Добавить еще",
      "description": "Описание",
      "details": "Детали",
      "files": {
        "placeholder": "Есть дополнительные файлы для загрузки? (таблички с данными, наклейки производителя и т.д.)",
        "addFilesLinks": "Добавить файлы / ссылки"
      },
      "save": "Сохранить",
      "cancel": "Отмена",
      "profile": "Профиль продукта",
      "assets": "Активы",
      "routines": "Рутины",
      "noAvailableRoutines": "Нет доступных рутин для добавления",
      "edit": "Редактировать",
      "delete": "Удалить",
      "confirmDelete": "Вы уверены, что хотите удалить продукт {{fileName}}?"
    },
    "specifications": {
      "title": "Все спецификации",
      "upload": "Загрузить данные",
      "download": "Загрузить",
      "add_more": "Добавить еще",
      "label_placeholder": "Название спецификации",
      "value_placeholder": "Значение",
      "delete_confirm": "Вы уверены, что хотите удалить эту спецификацию?",
      "upload_coming_soon": "Функциональность загрузки CSV скоро появится",
      "download_coming_soon": "Функциональность загрузки CSV скоро появится",
      "upload_success": "Спецификации успешно загружены",
      "upload_error": "Не удалось загрузить спецификации. Пожалуйста, попробуйте снова.",
      "download_error": "Не удалось загрузить спецификации. Пожалуйста, попробуйте снова.",
      "download_title": "Загрузить спецификации",
      "no_data_to_download": "Нет спецификаций для загрузки",
      "sharing_not_available": "Обмен файлами недоступен на этом устройстве"
    },
    "assignments": {
      "assets": "Активы",
      "routines": "Рутины",
      "files": "Файлы",
      "addons": "Дополнения",
      "searchPlaceholder": "Поиск по названию",
      "assetSearchPlaceholder": "Поиск названия актива",
      "routineSearchPlaceholder": "Поиск названия рутины",
      "fileSearchPlaceholder": "Поиск названия файла",
      "addonSearchPlaceholder": "Поиск названия дополнения"
    }
  },
  "file": {
    "list": {
      "files": "Файлы",
      "name": "Название",
      "products": "Продукты",
      "assets": "Активы",
      "addons": "Дополнения",
      "categories": "Категории",
      "lastUpdated": "Последнее обновление",
      "createdAt": "Создано"
    },
    "filter": {
      "searchPlaceholder": "Поиск названия файла",
      "columnButton": "Столбцы",
      "categories": "Категории",
      "searchCategories": "Поиск категорий",
      "deleteCategory": "Удалить категорию",
      "deleteCategoryMessage": "Вы уверены, что хотите удалить \"{{categoryName}}\"? Это удалит категорию из {{fileCount}} файлов.",
      "columns": {
        "name": "Название",
        "productsCount": "Продукты",
        "assetsCount": "Активы",
        "addonsCount": "Дополнения",
        "categories": "Категории",
        "updatedAt": "Последнее обновление",
        "createdAt": "Создано"
      },
      "columnSelection": "Столбцы"
    },
    "assignments": {
      "productsSearchPlaceholder": "Поиск названия продукта",
      "addonsSearchPlaceholder": "Поиск названия дополнения"
    },
    "create": {
      "label": "Добавить файл",
      "linkLabel": "Добавить ссылку",
      "title": "Заголовок",
      "linkUrl": "URL ссылки",
      "category": "Категория",
      "file": "Файл (только один файл)",
      "link": "Ссылка (только одна ссылка)",
      "add": "Добавить",
      "addLink": "Добавить ссылку",
      "titlePlaceholder": "Введите заголовок файла",
      "linkUrlPlaceholder": "Введите URL (например, https://example.com)",
      "categoryPlaceholder": "Выбрать категории",
      "categorySearchPlaceholder": "Поиск категорий",
      "createCategory": "Создать категорию",
      "enterCategoryNamePlaceholder": "Введите название категории",
      "creatingCategory": "Создание...",
      "selectCategory": "Выбрать категории",
      "searchCategory": "Поиск категорий",
      "emptyStateMessage": "Создайте категорию, введя название прямо в строке поиска.",
      "clickToUpload": "Нажмите для загрузки файла",
      "linkPlaceholder": "Введите URL (например, https://example.com)",
      "validation": {
        "title_required": "Требуется заголовок файла",
        "category_required": "Требуется хотя бы одна категория",
        "link_required": "Требуется URL ссылки",
        "link_invalid": "Пожалуйста, введите действительный URL"
      },
      "uploadError": "Не удалось загрузить файл. Пожалуйста, попробуйте снова.",
      "linkError": "Не удалось создать ссылку. Пожалуйста, попробуйте снова.",
      "placeholder": "Имя файла"
    },
    "dropdown": {
      "createFile": "Создать файл",
      "file": "Файл",
      "link": "Ссылка"
    },
    "tabs": {
      "products": "Продукты",
      "addons": "Дополнения"
    },
    "deleteFile": {
      "deleteFile": "Удалить файл",
      "alertBody1": "Вы уверены, что хотите удалить",
      "delete": "Удалить",
      "cancel": "Отмена"
    },
    "assets": {
      "title": "Активы",
      "name": "Название",
      "description": "Описание",
      "lastScanned": "Последнее сканирование",
      "lastAddress": "Последний адрес",
      "lastUpdated": "Последнее обновление",
      "noAssets": "Активы не найдены"
    }
  },
  "addOn": {
    "list": {
      "addOns": "Дополнения",
      "name": "Название",
      "product": "Продукты",
      "asset": "Активы",
      "media": "Файлы",
      "routines": "Рутины",
      "createdAt": "Создано",
      "updatedAt": "Последнее обновление",
      "addon": "Дополнение"
    },
    "filter": {
      "searchPlaceholder": "Поиск названия дополнения",
      "columnButton": "Столбцы",
      "columns": {
        "name": "Название",
        "product": "Продукты",
        "asset": "Активы",
        "media": "Файлы",
        "routines": "Рутины",
        "createdAt": "Создано",
        "updatedAt": "Последнее обновление"
      },
      "columnSelection": "Столбцы"
    },
    "create": {
      "label": "Создать дополнение",
      "validation": {
        "name_required": "Требуется название дополнения"
      },
      "cancel": "Отмена",
      "create": "Создать",
      "placeholder": "например, Дополнение 1"
    },
    "assignment": {
      "productSearchPlaceholder": "Поиск названия продукта",
      "mediaSearchPlaceholder": "Поиск названия файла",
      "routineSearchPlaceholder": "Поиск названия рутины",
      "success": "Продукты успешно назначены дополнению",
      "error": "Необходимо указать ID продуктов"
    },
    "files": {
      "title": "Файлы",
      "name": "Название",
      "type": "Тип",
      "extension": "Расширение",
      "textEmpty": "Файлы не найдены",
      "addFilesLinks": "Добавить файлы / ссылки",
      "save": "Сохранить",
      "delete": "Удалить",
      "list": {
        "name": "Название",
        "categories": "Категории"
      }
    },
    "textEmpty": "Нажмите '+ Создать дополнение', чтобы добавить ваше первое дополнение.",
    "edit": {
      "label": "Редактировать дополнение",
      "save": "Сохранить"
    },
    "deleteAddon": "Удалить дополнение"
  },
  "labels": {
    "confirmTextLine1": "Вы уверены, что хотите удалить метку \"{{labelName}}\"?",
    "confirmTextLine2": "Это удалит метку из {{activityCount}} существующих активностей.",
    "cancel": "Отмена",
    "delete": "Удалить",
    "editLabels": "Редактировать метки",
    "labels": "Метки",
    "yes": "Да"
  },
  "categories": {
    "confirmTextLine1": "Вы уверены, что хотите удалить категорию \"{{categoryName}}\"?",
    "confirmTextLine2": "Это удалит категорию из {{fileCount}} существующих файлов.",
    "cancel": "Отмена",
    "delete": "Удалить",
    "editCategories": "Редактировать категории",
    "categories": "Категории",
    "yes": "Да"
  },
  "integrations": {
    "providers": {
      "geotab": "GeoTab",
      "johnDeere": "John Deere Operations",
      "caseIh": "Case IH"
    },
    "attribution": {
      "autoSynced": "Синхронизировано автоматически"
    },
    "digest": {
      "title": "Синхронизирован {{count}} объект",
      "title_plural": "Синхронизировано {{count}} объектов",
      "titleSegment": "{{provider}} синхронизировал {{count}} объект",
      "titleSegment_plural": "{{provider}} синхронизировал {{count}} объектов",
      "failedDescription": "Ошибка синхронизации — данные могут быть устаревшими",
      "readingsCount": "{{count}} показание",
      "readingsCount_plural": "{{count}} показаний",
      "faultsCount": "{{count}} неисправность",
      "faultsCount_plural": "{{count}} неисправностей",
      "detailTitle": "Сводка синхронизации",
      "detailEmpty": "Нет данных по объектам"
    },
    "readings": {
      "fallbackRoutineName": "Показание"
    }
  },
  "share": {
    "expiresOn": "Срок действия ссылки истекает {{date}}"
  }
}
